import { memo } from 'react';

import Avatar from '@/ui/components/Avatar';
import formatPersonName from '@/utils/formatPersonName';

import type { Props } from './types';

/**
 * NOTE: This component is business/domain-specific and does not belong in the
 * generic UI primitives library (ui/components). It should be moved to a more
 * appropriate domain-specific location in the codebase.
 */
const PeopleAvatarList = ({ people, maxAvatars = 4 }: Props) => {
  const shown = people.slice(0, maxAvatars);
  const extra = people.length - maxAvatars;

  if (people.length === 0) {
    return <span className="text-xs text-gray-400 italic">None</span>;
  }

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {shown.map((a) => {
        const name = a.person
          ? formatPersonName({ person: a.person, withPronouns: false })
          : 'Unknown';
        return (
          <Avatar key={a.id} name={name} avatarUrl={a.person?.profile_image_url} size="small" />
        );
      })}
      {extra > 0 && <span className="text-xs text-gray-500 font-medium">+{extra}</span>}
    </div>
  );
};

export default memo(PeopleAvatarList);
